export const websites = [
  {
    id: 1,
    name: '韩漫网',
    slug: 'hanman-wang',
    url: 'https://www.hanmanwang.com',
    description: '国内领先的韩漫在线阅读平台，提供海量韩漫资源，每日更新热门韩漫，支持手机和电脑端流畅阅读，是韩漫爱好者的首选平台。',
    category: 'popular',
    tags: ['韩漫', '在线阅读', '每日更新'],
    rating: 4.9,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20digital%20reading%20platform%20with%20warm%20cozy%20interface%2C%20soft%20ambient%20lighting%2C%20modern%20minimalist%20design%2C%20artistic%20illustration%20style&width=600&height=320&seq=card-w01&orientation=landscape',
  },
  {
    id: 2,
    name: '韩漫之家',
    slug: 'hanman-zhijia',
    url: 'https://www.hanmanzhijia.com',
    description: '韩漫之家是专业的韩漫资源聚合平台，收录上万部韩漫作品，涵盖恋爱、奇幻、悬疑等多种题材，为用户提供优质的韩漫阅读体验。',
    category: 'popular',
    tags: ['韩漫资源', '多题材', '高品质'],
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20library%20collection%20display%20with%20organized%20shelves%2C%20warm%20reading%20atmosphere%2C%20modern%20clean%20design%2C%20artistic%20book%20covers&width=600&height=320&seq=card-w02&orientation=landscape',
  },
  {
    id: 3,
    name: '韩漫屋',
    slug: 'hanman-wu',
    url: 'https://www.hanmanwu.com',
    description: '韩漫屋专注于提供免费韩漫在线观看服务，界面简洁清新，分类清晰，更新速度快，让漫迷随时随地畅享韩漫阅读乐趣。',
    category: 'free',
    tags: ['免费韩漫', '在线观看', '更新快'],
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=modern%20webtoon%20reading%20app%20on%20tablet%20screen%2C%20clean%20minimal%20interface%2C%20cozy%20cafe%20background%2C%20warm%20lighting%2C%20Korean%20comics%20display&width=600&height=320&seq=card-w03&orientation=landscape',
  },
  {
    id: 4,
    name: '韩漫吧',
    slug: 'hanman-ba',
    url: 'https://www.hanmanba.com',
    description: '韩漫吧是一个活跃的韩漫社区平台，不仅有丰富的韩漫资源，还有漫迷交流社区，用户可以分享观后感、推荐好漫，互动性强。',
    category: 'popular',
    tags: ['韩漫社区', '漫迷交流', '资源丰富'],
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=vibrant%20online%20community%20forum%20for%20Korean%20comics%20fans%2C%20colorful%20chat%20interface%2C%20warm%20social%20atmosphere%2C%20modern%20web%20design&width=600&height=320&seq=card-w04&orientation=landscape',
  },
  {
    id: 5,
    name: '韩漫天堂',
    slug: 'hanman-tiantang',
    url: 'https://www.hanmantt.com',
    description: '韩漫天堂提供高清韩漫在线阅读，画质清晰、翻译精准，支持离线缓存功能，让用户在任何场景下都能畅快阅读喜爱的韩漫作品。',
    category: 'premium',
    tags: ['高清画质', '离线缓存', '精准翻译'],
    rating: 4.8,
    image: 'https://readdy.ai/api/search-image?query=high%20quality%20digital%20comic%20reader%20with%20vivid%20illustrations%2C%20premium%20reading%20experience%2C%20elegant%20dark%20mode%20interface%2C%20artistic%20manga%20panels&width=600&height=320&seq=card-w05&orientation=landscape',
  },
  {
    id: 6,
    name: '漫客韩漫',
    slug: 'manke-hanman',
    url: 'https://www.mankehanman.com',
    description: '漫客韩漫是新兴的韩漫阅读平台，界面设计年轻化，推荐算法精准，能根据用户喜好智能推荐韩漫作品，深受年轻漫迷喜爱。',
    category: 'new',
    tags: ['智能推荐', '年轻化', '新平台'],
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=trendy%20youth%20oriented%20webtoon%20platform%20with%20personalized%20recommendations%2C%20colorful%20modern%20interface%2C%20vibrant%20illustration%20banners&width=600&height=320&seq=card-w06&orientation=landscape',
  },
  {
    id: 7,
    name: '韩漫汇',
    slug: 'hanman-hui',
    url: 'https://www.hanmanhui.com',
    description: '韩漫汇汇聚全网韩漫资源，打造一站式韩漫网址导航服务，提供多平台入口汇总，帮助漫迷快速找到想看的韩漫作品，省时省力。',
    category: 'aggregator',
    tags: ['网址导航', '资源汇总', '一站式'],
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=comprehensive%20directory%20portal%20for%20Korean%20webtoons%2C%20organized%20grid%20of%20platform%20links%2C%20clean%20navigational%20design%2C%20warm%20inviting%20interface&width=600&height=320&seq=card-w07&orientation=landscape',
  },
  {
    id: 8,
    name: '韩漫阁',
    slug: 'hanman-ge',
    url: 'https://www.hanmange.com',
    description: '韩漫阁以精品韩漫著称，精选优质韩漫作品，提供舒适的阅读界面和流畅的翻页体验，适合追求品质阅读的韩漫爱好者使用。',
    category: 'premium',
    tags: ['精品韩漫', '舒适阅读', '精选内容'],
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=elegant%20curated%20Korean%20manhwa%20collection%20display%2C%20refined%20reading%20environment%2C%20minimalist%20bookshelf%20design%2C%20soft%20warm%20lighting&width=600&height=320&seq=card-w08&orientation=landscape',
  },
  {
    id: 9,
    name: '韩漫世界',
    slug: 'hanman-shijie',
    url: 'https://www.hanmanshijie.com',
    description: '韩漫世界是一个国际化的韩漫平台，提供多语言版本的韩漫阅读，支持中文、英文、日文等多种语言，让全球漫迷都能享受韩漫乐趣。',
    category: 'free',
    tags: ['多语言', '国际化', '免费阅读'],
    rating: 4.5,
    image: 'https://readdy.ai/api/search-image?query=global%20Korean%20webtoon%20platform%20with%20multilingual%20support%2C%20world%20map%20background%2C%20modern%20clean%20interface%2C%20inclusive%20design&width=600&height=320&seq=card-w09&orientation=landscape',
  },
  {
    id: 10,
    name: '韩漫集',
    slug: 'hanman-ji',
    url: 'https://www.hanmanji.com',
    description: '韩漫集专注于韩漫合集整理，提供完整系列的韩漫打包阅读，方便漫迷一次性追完心爱的韩漫作品，支持收藏和书签功能。',
    category: 'premium',
    tags: ['合集整理', '系列完整', '收藏功能'],
    rating: 4.6,
    image: 'https://readdy.ai/api/search-image?query=organized%20collection%20of%20Korean%20comics%20series%2C%20neat%20bookmark%20system%2C%20digital%20library%20aesthetic%2C%20warm%20reading%20nook&width=600&height=320&seq=card-w10&orientation=landscape',
  },
  {
    id: 11,
    name: '极速韩漫',
    slug: 'jisu-hanman',
    url: 'https://www.jisuhanman.com',
    description: '极速韩漫以加载速度快著称，采用先进的CDN加速技术，确保漫画页面秒开，为追求极致阅读速度的漫迷提供流畅体验。',
    category: 'new',
    tags: ['加载快速', 'CDN加速', '流畅体验'],
    rating: 4.4,
    image: 'https://readdy.ai/api/search-image?query=fast%20loading%20webtoon%20platform%20with%20speed%20indicator%2C%20minimalist%20lightning%20themed%20design%2C%20modern%20tech%20aesthetic%2C%20clean%20interface&width=600&height=320&seq=card-w11&orientation=landscape',
  },
  {
    id: 12,
    name: '全韩漫',
    slug: 'quan-hanman',
    url: 'https://www.quanhanman.com',
    description: '全韩漫致力于打造最全的韩漫资源库，收录各类韩漫作品超过十万部，拥有强大的搜索引擎，帮助用户精准定位想看的韩漫。',
    category: 'aggregator',
    tags: ['资源全面', '搜索引擎', '海量收录'],
    rating: 4.7,
    image: 'https://readdy.ai/api/search-image?query=massive%20searchable%20database%20of%20Korean%20webtoons%2C%20powerful%20search%20interface%2C%20extensive%20catalog%20display%2C%20modern%20library%20design&width=600&height=320&seq=card-w12&orientation=landscape',
  },
];